import { isValidPhoneNumber, parsePhoneNumber } from '@nimbus-library/features/shared/components/material/core';
import { IUserAutocompleteOption } from '@nimbus-library/features/shared/components/material/input-user-autocomplete/i-user-auto-complete-option.model';
import { UserAutoCompleteCallOptionType } from '@nimbus-library/features/shared/services/user-search/models/user-auto-complete-value-type';

export function userAutocompletePhoneResultFromSearchValue(value: string): IUserAutocompleteOption[] {
  const result = parsePhoneNumber(value);

  if (isValidPhoneNumber(result.value)) {
    return [
      {
        id: result.value,
        name: null,
        isPSTN: true,
        image: null,
        initials: result.value[0] + result.value[1],
        hasCallOptions: false,
        callOptions: [
          {
            text: result.value,
            type: UserAutoCompleteCallOptionType.mobile,
            isDisabled: false,
            icon: null,
            userId: result.value,
          },
        ],
      },
    ];
  }
  return [];
}
